<template>
	<div class="login-form">
		<router-link :to="{ name: 'home' }" class="lineup-home">
			<img class="logo-lineup" src="../assets/logos/mate/lineup-black.svg" alt="LineUp Tickets">
		</router-link>
		<span class="login-title">Iniciar sesión</span>
		<div class="input-row">
			<div class="input-group-wrapper input-group-wrapper-100">
				<social-button
					:logo="'@/assets/GoogleLogo.svg'"
					:text="'Google'"
					:url="googleUrl"
				></social-button>
			</div>
			<!-- <div class="input-group-wrapper input-group-wrapper-50">
				<social-button
					:logo="'@/assets/FacebookLogo.svg'"
					:text="'Facebook'"
					:url="facebookUrl"
				></social-button>
			</div> -->
		</div>
		<div class="input-row">
			<div class="input-group-divider">
				<span>o inicia sesión con tu correo</span>
			</div>
		</div>
		<div class="input-group" :class="{ 'form-group--error': $v.email.$error }">
			<label class="form__label" for="email">Correo electrónico</label>
			<input
				class="form__input"
				type="email"
				id="email"
				name="email"
				v-model="email"
				v-on:keyup.enter="onSubmit"
				:class="{ 'form-input--error': $v.email.$error }"
				@keydown.space.prevent
			/>
		</div>
		<div class="error-group" v-if="$v.email.$dirty">
			<div class="error" v-if="!$v.email.required">
				Ingresa tu correo electrónico.
			</div>
			<div class="error" v-else-if="!$v.email.email">
				Correo electrónico inválido.
			</div>
		</div>
		<div
			class="input-group"
			:class="{ 'form-group--error': $v.password.$error }"
		>
			<label class="form__label" for="password">Contraseña</label>
			<input
				class="form__input"
				type="password"
				id="password"
				name="password"
				v-model="password"
				v-on:keyup.enter="onSubmit"
				:class="{ 'form-input--error': $v.password.$error }"
				@keydown.space.prevent
				v-if="!showPassword"
			/>
			<input
				class="form__input"
				type="text"
				id="password"
				name="password"
				v-model="password"
				v-on:keyup.enter="onSubmit"
				:class="{ 'form-input--error': $v.password.$error }"
				@keydown.space.prevent
				v-else
			/>
			<i
				class="bx bx-show input-icon"
				@click="showPassword = !showPassword"
				v-if="showPassword"
			></i>
			<i
				class="bx bx-hide input-icon"
				@click="showPassword = !showPassword"
				v-else
			></i>
		</div>
		<div class="error-group" v-if="$v.password.$dirty">
			<div class="error" v-if="!$v.password.required">
				Ingresa tu contraseña.
			</div>
		</div>
		<div class="input-group forgot-password">
			<span @click.prevent="$emit('forgotPassword')"
				>¿Olvidaste la contraseña?</span
			>
		</div>
		<div class="error-area" v-if="loginError">
			<span>{{ loginError }}</span>
		</div>
		<button @click.prevent="onSubmit" :disabled="submitingForm" v-if="!submitingForm">
			Iniciar sesión
		</button>
		<button disabled="disabled" v-if="submitingForm">
			Iniciando sesión <clip-loader class="login-loader" :color="'var(--color-darker)'" :size="'12px'" ></clip-loader>
		</button>
		<div class="login-disclaimer">
			<span>Al iniciar sesión, aceptas las <router-link :to="{ name: 'terminos-y-condiciones' }">Condiciones de servicio</router-link> de LineUp Tickets y reconoces que leíste nuestra <router-link :to="{ name: 'politica-de-privacidad' }">Política de privacidad</router-link>.</span>
			<div class="line"></div>
		</div>
		<p>¿Todavía no tienes una cuenta?<router-link :to="{ name: 'register' }">Regístrate</router-link></p>
	</div>
</template>

<script>
	import { required, email } from "vuelidate/lib/validators";
	import SocialButton from "./SocialButton.vue";

	import { createNamespacedHelpers, mapState } from "vuex";
	import { getFacebookUrl, getGoogleUrl } from '../utils';
	const { mapActions } = createNamespacedHelpers("AuthModule");

	import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

	export default {
		data() {
			return {
				googleUrl: '',
				facebookUrl: '',
				email: null,
				password: null,
				showPassword: false,
				loginError: null,
				submitingForm: false,
			};
		},
		validations: {
			email: {
				required,
				email,
			},
			password: {
				required,
			},
		},
		computed: {
			...mapState([
				'fromStateSocial'
			])
		},
		components:{
			'social-button': SocialButton,
			ClipLoader
		},
		metaInfo: {
			title: 'Iniciar sesión',
			titleTemplate: '%s 🎟 LineUp Tickets'
		},
		methods: {
			...mapActions(['login']),

			async onSubmit() {
				this.submitingForm = true;
				this.$v.$touch();

				if (!this.$v.$invalid) {
					this.loginError = null;

					const user = {
						email: this.email,
						password: this.password,
					};

					let payload = {
						Usuario: user,
						OrganizadorActivo: null
					}

					let res = await this.login(payload);
					
					if(res.IsOk === true){
						this.submitingForm = false;
						this.$emit('success');
						this.$store.dispatch('showSuccess', '¡Bienvenido de vuelta!')
					} else {
						this.submitingForm = false;
						this.loginError = res.Error;
					}
				}

				this.submitingForm = false;
			},
		},
		mounted(){
			this.googleUrl = getGoogleUrl(this.fromStateSocial);
			this.facebookUrl = getFacebookUrl(this.fromStateSocial)
		}
	};
</script>

<style lang="scss" scoped>
	.login-form {
		width: 100%;
		padding: 0px;
		@include flex(column, center, flex-start);
		position: relative;

		.lineup-home{
			display: none;
			text-decoration: none;
			cursor: pointer;
			margin-bottom: 20px;

			.logo-lineup{
				height: 42px;
				width: auto;
			}
		}

		.login-title {
			font-family: var(--font-sora);
			font-weight: var(--fw-700);
			font-size: 26px;
			margin-bottom: 7px;
		}

		.login-subtitle {
			font-weight: var(--fw-400);
			font-size: 14px;
			margin-bottom: 15px;
			line-height: 1.6em;
		}

		.input-row {
			width: 100%;
			margin: 0px;
			@include flex(row, space-between, flex-start);

			.input-group-wrapper {
				width: 100%;
				margin: 10px 0px;
				padding: 0px;
				position: relative;
				@include flex(column, center, flex-start);

				&.input-group-wrapper-50 {
					width: calc(50% - 8px);
				}
			}

			.input-group-divider {
				width: 100%;
				@include flex(row, center, center);
				position: relative;
				margin: 7px 0px;

				span {
					line-height: 1em;
					background-color: var(--color-white);
					padding: 4px;
					z-index: 1;
					font-size: 11px;
				}

				&:after {
					content: "";
					position: absolute;
					height: 0.5px;
					width: 100%;
					background-color: #cfcfcf;
					left: 0;
					top: 50%;
					transform: translateY(-50%);
				}
			}
		}

		.input-group {
			width: 100%;
			margin: 8px 0px 4px 0px;
			position: relative;
			@include flex(column, flex-end, flex-start);

			label {
				font-size: 13px;
				font-weight: var(--fw-600);
				margin-top: 0px;
				margin-bottom: 6px;
				line-height: 1em;
			}

			input {
				-webkit-appearance: none;
				appearance: none;
				border: none;
				width: 100%;
				padding: 0px 36px 0px 14px;
				font-size: 14px;
				font-weight: var(--fw-400);
				line-height: 1.4em;
				width: 100%;
				border-radius: 8px;
				height: 44px;
				outline: none;
				box-shadow: rgb(176, 176, 176) 0px 0px 0px 1px inset;
				// box-shadow: 0 0 #0000,0 0 #0000, 0 1px 2px 0 rgba(0,0,0,.05);

				&::placeholder {
					color: #9aa5b5;
					opacity: 1;
				}

				&:-ms-input-placeholder {
					color: #9aa5b5;
				}

				&::-ms-input-placeholder {
					color: #9aa5b5;
				}

				&:focus-within {
					@include transition(all 0.2s);
					box-shadow: rgb(34, 34, 34) 0px 0px 0px 2px inset;

					&.form-input--error {
						box-shadow: var(--color-red-error) 0px 0px 0px 2px inset;
					}
				}

				&.form-input--error {
					box-shadow: var(--color-red-error) 0px 0px 0px 1px inset;
				}
			}

			input:-webkit-autofill,
			input:-webkit-autofill:hover,
			input:-webkit-autofill:focus,
			textarea:-webkit-autofill,
			textarea:-webkit-autofill:hover,
			textarea:-webkit-autofill:focus,
			select:-webkit-autofill,
			select:-webkit-autofill:hover,
			select:-webkit-autofill:focus {
				border: none;
				-webkit-text-fill-color: var(--color-darker);
				box-shadow: rgb(176, 176, 176) 0px 0px 0px 1px inset,
					0 0 0px 1000px var(--color-white) inset;
				-webkit-box-shadow: rgb(176, 176, 176) 0px 0px 0px 1px inset,
					0 0 0px 1000px var(--color-white) inset;

				&:focus-within {
					box-shadow: rgb(34, 34, 34) 0px 0px 0px 2px inset,
						0 0 0px 1000px var(--color-white) inset;
				}
			}

			.input-icon {
				position: absolute;
				color: rgb(176, 176, 176);
				bottom: 12px;
				font-size: 20px;
				right: 12px;
				cursor: pointer;

				&:hover {
					@include transition(all 0.2s);
					color: var(--color-darker);
				}
			}

			&.form-group--error {
				label {
					color: var(--color-red-error);
				}
			}

			&.forgot-password {
				@include flex(row, flex-end, center);

				span {
					font-size: 11px;
					text-align: right;
					color: var(--color-darker);
					font-weight: var(--fw-600);
					@include transition(all 0.2s);
					cursor: pointer;

					&:hover {
						text-decoration: underline;
					}
				}
			}
		}

		.error-group {
			width: 100%;
			@include flex(column, center, flex-start);

			.error {
				font-size: 11px;
				color: var(--color-red-error);
				line-height: 1em;
			}
		}

		button {
			background-color: #222222;
			border: none;
			border-radius: 8px;
			outline: none;
			padding: 14px;
			width: 100%;
			color: var(--color-white);
			font-size: 14px;
			font-weight: var(--fw-600);
			font-family: var(--font-sora);
			line-height: 1.4em;
			letter-spacing: 1px;
			margin-top: 14px;
			@include transition(all 0.2s);
			cursor: pointer;
			@include flex(row, center, center);

			&:hover {
				background-color: var(--color-black);
			}

			&:disabled {
				background-color: #e8e9eb;
				color: var(--color-darker);
				border-color: #e8e9eb;
				cursor: not-allowed;
			}
		}

		.login-loader{
			margin-left: 10px;
			margin-bottom: -3px;
		}

		.error-area {
			width: 100%;
			@include flex(row, flex-start, center);
			padding: 12px;
			margin-top: 10px;
			border-radius: 8px;
			background: rgb(255, 243, 243);

			span {
				color: rgb(242, 53, 53);
				font-size: 14px;
				font-weight: var(--fw-500);
			}
		}

		p {
			font-weight: var(--fw-600);
			font-size: 13px;
			text-align: center;
			width: 100%;
			margin-top: 15px;

			a {
				margin-left: 5px;
				color: var(--color-darker);
				text-decoration: underline;
			}
		}

		.login-disclaimer {
			width: 100%;
			margin-top: 15px;
			@include flex(column, flex-start, center);

			span {
				font-size: 11px;
				text-align: center;
				width: 80%;
				padding-bottom: 15px;
				line-height: 1.5em;
				color: #9aa5b5;

				a {
					color: var(--color-darker);
					font-weight: var(--fw-600);
				}
			}

			.line {
				width: 30%;
				background-color: var(--color-border);
				height: 1px;
			}
		}
	}

	@media screen and (max-width: 968px){
		.login-form{
			.lineup-home{
				@include flex(row, flex-start, center);
			}
		}
	}

	@media screen and (max-width: 450px){
		.login-form{
			.login-title{
				font-size: 22px;
			}

			.login-disclaimer{
				span{
					width: 100%;
				}
			}
		}
	}

	@media screen and (max-height: 810px){
		.login-form{
			.login-title{
				font-size: 22px;
			}

			.input-group{
				margin: 4px 0px 3px 0px;

				label {
					font-size: 12px;
					margin-bottom: 4px;
				}

				input{
					height: 40px;
					font-size: 13px;
				}
			}

			button{
				margin-top: 10px;
				font-size: 14px;
				padding: 12px;
			}

			p{
				margin-top: 12px;
			}

			.login-disclaimer{
				span{
					width: 100%;
					padding-bottom: 12px;
				}
			}
		}
	}
</style>
